import styled from '@emotion/styled';
import { Loader, Segment, Table } from 'semantic-ui-react';

import { useGetLastTenImportsQuery } from 'store/bulk-actions/bulkActionsApi';
import { BulkDataType } from 'types';
import { formatDateTime } from 'utils';

interface LastUploadsListSegmentProps {
  bulkDataType: BulkDataType;
}

export const LastUploadsListSegment = ({ bulkDataType }: LastUploadsListSegmentProps) => {
  const { currentData: uploads = [], isFetching } = useGetLastTenImportsQuery(bulkDataType);

  return (
    <Segment>
      <h4>Last uploads</h4>

      <Table data-testid="bulk-last-uploads-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={12}>Filename</Table.HeaderCell>
            <Table.HeaderCell width={4}>Uploaded on</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {uploads.map((item) => (
            <Table.Row key={item.importId}>
              <S.Cell width={12}>{item.fileName}</S.Cell>
              <S.Cell width={4}>{formatDateTime(item.scheduledTimestamp)}</S.Cell>
            </Table.Row>
          ))}
        </Table.Body>

        {uploads.length === 0 && (
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan={2} textAlign="center">
                {isFetching ? <Loader active inline size="small" /> : 'No results'}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </Segment>
  );
};

const S = {
  Cell: styled(Table.Cell)`
    word-break: break-all;
  `,
};
